import { Audit_Log } from "./audit_log";

export class Company {

  company_Id = 0;      
  company_Name = '';  
  account_Num = '';  
  address_1 = '';   
  address_2 = '';  
  address_3 = ''; 
  address_4 = '';
  county = '';   
  postcode = '';
  telephone = '';
  fax = '';
  email = '';
  customer_Type_Id = 0;
  customer_Type = '';
  expired = false;

  audit_Log = new Audit_Log();
  is_edit: boolean;
}
